/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-markdown';
/*------------------------------------------------*/
/* INTERNAL DEPENDENCIES
/*------------------------------------------------*/


const Tip = (props) => {
  const {
    text,
    ...rest
  } = props;

  return (
    <div {...rest}>
      <Markdown
        allowedTypes={['link', 'paragraph', 'text']}
        linkTarget="_blank"
      >
        {text}
      </Markdown>
    </div>
  );
};

/*------------------------------------------------*/
/* PROP TYPES
/*------------------------------------------------*/
Tip.propTypes = {
  text: PropTypes.string.isRequired,
};

/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default Tip;
